import React, { useEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

import { ROUTES } from 'consts';
import { useParamValues } from 'hooks/url.hook';
import { AuthLayout } from 'layouts';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

export const AuthNavigator = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orgSlug: orgSlugFromUser, isLoggedIn, emailVerified } = useAppSelector(selectCurrentUserInfo);
  const { orgSlug: orgSlugFromUrl } = useParamValues(['orgSlug']);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(`/${ROUTES.AUTH}/${ROUTES.AUTH_LOGIN}`, { state: { from: location.pathname }, replace: true });
    } else if (!emailVerified) {
      navigate(`/${ROUTES.VERIFICATION}/${ROUTES.VERIFICATION_REQUEST}`, {
        state: { from: location.pathname },
        replace: true,
      });
    } else if (orgSlugFromUrl !== orgSlugFromUser) {
      navigate(location.pathname.replace(orgSlugFromUrl, orgSlugFromUser), { replace: true });
    } else if (location.pathname === `/${orgSlugFromUrl}` || location.pathname === `/${orgSlugFromUrl}/`) {
      navigate(ROUTES.DASHBOARD.replace(':orgSlug', orgSlugFromUrl), { replace: true });
    }
  }, [isLoggedIn, orgSlugFromUser, orgSlugFromUrl, navigate, location.pathname]);

  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};
